module.exports = __webpack_public_path__ + "static/media/genai.40c6fa59.jpg";